import { useQuery } from "react-query"
import { request } from "../util/request"

export function usePayoutTicketPurchases(
  payoutId: number,
  page = 1,
  perPage = 100,
) {
  return useQuery(
    ["payoutTicketPurchases", payoutId, page, perPage],
    getTicketPurchasesForPayoutId,
    {
      keepPreviousData: true,
    },
  )
}

const getTicketPurchasesForPayoutId = async ({ queryKey }: { queryKey: readonly unknown[] }) => {
  const [key, id, page, perPage] = [...queryKey]
  return await request({
    queryKey: [
      key,
      {
        path: `/api/v1/payouts/${id}/ticket_purchases`,
        params: { per_page: perPage, page: page },
      },
    ],
  })
}
